<template>
  <b-col
    v-if="exibir"
    lg="3"
    md="6"
    sm="12"
  >
    <validation-provider
      #default="{ errors }"
      name="Tolerância para registro pós-término"
      :rules="disabled ? '' : 'integer|between:0,365'"
    >
      <b-form-group
        label="Tolerância para registro pós-término (dias)"
        label-for="tolerancia-dias-pos-termino"
      >
        <b-form-input
          id="tolerancia-dias-pos-termino"
          :value="value"
          type="number"
          min="0"
          max="365"
          placeholder="30"
          :state="errors.length > 0 ? false : null"
          :disabled="disabled"
          autocomplete="off"
          @wheel.prevent
          @keydown="helpers.blockNonIntegerKey"
          @paste="helpers.blockNonIntegerPaste"
          @input="onInput"
        />
        <small v-if="errors[0]" class="text-danger d-block">
          {{ errors[0] }}
        </small>
        <small class="text-muted">
          Quantidade de dias após o término da campanha em que ainda será permitido registrar vacinação. Se não preenchido, será utilizado o padrão de 30 dias.
        </small>
      </b-form-group>
    </validation-provider>
  </b-col>
</template>

<script>
import { BCol, BFormGroup, BFormInput } from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import { between, integer } from '@validations'
import helpers from '@/helpers'

export default {
  name: 'ToleranciaInput',

  components: {
    BCol,
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },

  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    exibir: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      helpers,
      between,
      integer,
    }
  },

  methods: {
    onInput(val) {
      if (val === '' || val === null) {
        this.$emit('input', null)
        return
      }
      const parsed = Number.parseInt(val, 10)
      this.$emit('input', Number.isNaN(parsed) ? null : parsed)
    },
  },
}
</script>
